import React from 'react';
import {
  Box, Typography, Button, CardMedia,
} from '@mui/material';
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
import { useNavigate } from 'react-router-dom';
import heroImg from '../../../resources/finalBG.png';

const Hero = () => {
  const navigate = useNavigate();

  const handleEnroll = () => {
    navigate('/apply_now');
  };

  return (
    <Box
      id="home"
      sx={{
        display: 'flex', flexDirection: 'column', justifyContent: 'space-between', alignItems: 'center', padding: '20px 0', width: '100%', marginTop: '60px',
      }}
    >
      <Box sx={{
        display: 'flex', flexDirection: { xs: 'column', sm: 'row' }, justifyContent: 'space-between', alignItems: 'center', gap: { xs: '30px', sm: 'none' },
      }}
      >
        <Box sx={{ width: { xs: '90%', sm: '48%' } }}>
          <Typography sx={{
            background: 'linear-gradient(to right, #AE67FA, #F49867)', textFillColor: 'transparent', backgroundClip: 'text', fontSize: { xs: '35px', sm: '60px' }, fontWeight: '700', lineHeight: { xs: '40px', sm: '75px' },
          }}
          >
            Coding and creative courses for kids
          </Typography>
          <Typography sx={{ color: '#81AFDD', lineHeight: 'auto', padding: '20px 0' }}>There&apos;s no limit what your kids can achieve! Give them a quality online learning experience that will encourage them to imagine and create alongside their peers.</Typography>
          <Box sx={{ display: 'flex', flexDirection: { xs: 'column', sm: 'row' }, gap: '30px' }}>
            <Button
              onClick={handleEnroll}
              variant="contained"
              sx={{
                backgroundColor: '#AE67FA', color: '#fff', '&:hover': { background: '#F49867' }, padding: '8px 35px',
              }}
            >
              ENROLL NOW
              <KeyboardArrowRightIcon />
            </Button>
            <Button
              component="a"
              href="#whoweare"
              variant="outlined"
              sx={{
                backgroundColor: 'transparent', color: '#F49867', border: '1px solid #F49867', '&:hover': { border: '1px solid #AE67FA', color: '#AE67FA' }, padding: '8px 35px',
              }}
            >
              LEARN MORE
              <KeyboardArrowRightIcon />
            </Button>
          </Box>
        </Box>
        <Box sx={{ width: { xs: '90%', sm: '45%' } }}>
          <CardMedia
            component="img"
            width="100%"
            image={heroImg}
            alt="Paella dish"
          />
        </Box>
      </Box>
    </Box>
  );
};

export default Hero;
